import React, { useState, useEffect } from "react";
import { Button, FormInput, LoadingSpinner } from "../Common.jsx";
import { DynamicIcon } from "../icons.jsx";

export default function BrandingForm({ tenantId, data, token, onSave, isLastStep, saving }) {
  const [form, setForm] = useState({
    logo_url: "",
    theme_color: "#3b82f6",
    accent_color: "#1e40af",
    login_banner_url: "",
    email_template_html: ""
  });

  useEffect(() => {
    setForm(prev => ({
      ...prev,
      ...data
    }));
  }, [data]);

  const update = (k, v) => setForm({ ...form, [k]: v });

  return (
    <div className="max-w-4xl space-y-8">

      <div className="bg-white dark:bg-gray-800 rounded-xl border p-6 space-y-6">
        <h3 className="font-bold text-gray-700 dark:text-gray-300">Visual Identity</h3>
        <div className="grid grid-cols-2 gap-6">
          <FormInput label="Logo URL" value={form.logo_url} onChange={(e) => update("logo_url", e.target.value)} />
          <FormInput label="Login Banner URL" value={form.login_banner_url} onChange={(e) => update("login_banner_url", e.target.value)} />
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium mb-1">Primary Color</label>
            <div className="flex gap-2">
              <input type="color" className="h-10 w-10 rounded cursor-pointer border-0" value={form.theme_color} onChange={(e) => update("theme_color", e.target.value)} />
              <input type="text" className="flex-1 p-2 border rounded" value={form.theme_color} onChange={(e) => update("theme_color", e.target.value)} />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Accent Color</label>
            <div className="flex gap-2">
              <input type="color" className="h-10 w-10 rounded cursor-pointer border-0" value={form.accent_color} onChange={(e) => update("accent_color", e.target.value)} />
              <input type="text" className="flex-1 p-2 border rounded" value={form.accent_color} onChange={(e) => update("accent_color", e.target.value)} />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-xl border p-6 space-y-4">
        <h3 className="font-bold text-gray-700 dark:text-gray-300">Email Branding</h3>
        <label className="block text-sm font-medium mb-1">HTML Template Override</label>
        <textarea
          className="w-full h-40 p-2 text-sm font-mono border rounded bg-gray-50 dark:bg-gray-900"
          placeholder="<html>...</html>"
          value={form.email_template_html}
          onChange={(e) => update("email_template_html", e.target.value)}
        />
      </div>

      <div className="sticky bottom-0 z-10 bg-white/90 dark:bg-gray-800/90 backdrop-blur border-t dark:border-gray-700 p-4 -mx-6 -mb-6 mt-8 flex justify-end shadow-lg rounded-b-xl">
        <Button
          onClick={() => onSave(form)}
          disabled={saving}
          className={isLastStep ? "bg-green-600 hover:bg-green-700 text-white px-8 shadow-md min-w-[170px] justify-center" : "px-6 shadow-md"}
        >
          {saving ? (
            <>
              <LoadingSpinner size={16} className="mr-2 text-white" />
              {isLastStep ? "Provisioning..." : "Saving..."}
            </>
          ) : isLastStep ? (
            <>Save & Finish <DynamicIcon name="CheckCircle" className="ml-2 w-4 h-4" /></>
          ) : (
            "Save Branding"
          )}
        </Button>
      </div>
    </div>
  );
}
